import { defineStore } from 'pinia';
import { getMenuItemsByIds } from '@/router/menu';
import {defaultPermissions} from '@/router/index'
export const userData = defineStore('user', {
    state: () => ({
      imgHead: sessionStorage.getItem('imgHead') || '../assets/img/touxiang.jpg', //头像
      imgDecoration: sessionStorage.getItem('imgDecoration') || '../assets/img/beijin.jpg', //背景图片
      sex: "", //头像
      loginKey: sessionStorage.getItem('loginKey') ||"", //用户唯一标识key
      role: sessionStorage.getItem('role') || '',
      name: sessionStorage.getItem('name') || '', // 用户名
      permiss: sessionStorage.getItem('permiss') || '', // 用户菜单权限
      permissArray: (() => {// 用户菜单权限
          try {
              const storedPermiss = sessionStorage.getItem('permiss');
              if (!storedPermiss) return [];
              // 尝试解析 JSON 格式
              const permissions = JSON.parse(storedPermiss) || [];
              return getMenuItemsByIds(permissions) || [];
          } catch (e) {
              // 处理逗号分隔格式
              const storedPermiss = sessionStorage.getItem('permiss');
              if (typeof storedPermiss === 'string' && storedPermiss) {
                  const permissions = storedPermiss.split(',').filter(item => item.trim() !== '');
                  return getMenuItemsByIds(permissions) || [];
              }
              return [];
          }
      })(), 
      unReadMessageNum:  0, //消息通知的数量
      unReadMessage: [], //未读消息通知数据
    }),
    actions: {      setOrgDataList(newOrgDataList) {
        this.orgDataList = newOrgDataList;
      },
      setLoginKey(loginKey) {
        this.loginKey = loginKey;
        sessionStorage.setItem('loginKey', loginKey);
      },
      setSex(sex) {
        this.sex = sex;
      },
      setUnReadMessageNum(newMessageNum) {
        this.unReadMessageNum = newMessageNum;
      },
      setUnReadMessage(newMessage) {
        this.unReadMessage = newMessage;
      },
      setImgHead(newUrl) {
        this.imgHead = newUrl;
        sessionStorage.setItem('imgHead', newUrl);
      },
      setImgDecoration(newImgDecoration) {
        this.imgDecoration = newImgDecoration;
        sessionStorage.setItem('imgDecoration', newImgDecoration);
      },
      setName(newName) {
        this.name = newName;
        sessionStorage.setItem('name', newName); 
      },
      setPermiss(newPermiss) {
        this.permiss = newPermiss;
        let permissions = [];
        if (typeof newPermiss === 'string') {
            permissions = JSON.parse(newPermiss) || [];
        } else if (Array.isArray(newPermiss)) {
            permissions = newPermiss;
        }
        let newPermissArray = getMenuItemsByIds( permissions );
        this.permissArray = newPermissArray;
        sessionStorage.setItem('permiss', newPermiss);
      },
      setAll(data) { 
        const { permiss, name, imgHead, imgDecoration, role } = data;
        const loginKey = data.loginKey || data.token || '';
        this.permiss = permiss;
        this.name = name;
        this.imgHead = imgHead;
        // 添加类型判断处理
        let permissions = [];
        if (typeof permiss === 'string') {
            try {
                permissions = JSON.parse(permiss) || [];
            } catch (e) {
                permissions = permiss.split(',').filter(item => item.trim() !== '');
            }
        } else if (Array.isArray(permiss)) {
            permissions = permiss;
        }
    
        let newPermissArray = getMenuItemsByIds(permissions);
        this.permissArray = newPermissArray;
        this.imgDecoration = imgDecoration;
        this.role = role;
        this.loginKey = loginKey;
        sessionStorage.setItem('loginKey', loginKey);
        sessionStorage.setItem('imgDecoration', imgDecoration);
        sessionStorage.setItem('permiss', permiss); 
        sessionStorage.setItem('name', name); 
        sessionStorage.setItem('imgHead', imgHead);
        sessionStorage.setItem('role', role);
      },
      removeImgHead() {
        this.imgHead = '../assets/img/img.jpg'; // 设置默认值
        sessionStorage.removeItem('imgHead');
      },
      removeName() {
          this.name = '';
          sessionStorage.removeItem('name');
      },
      removePermiss() {
          this.permiss = '';
          sessionStorage.removeItem('permiss');
      },
      removeAll() {
          this.imgHead = '../assets/img/img.jpg'; // 设置默认值
          this.name = '';
          this.permiss = '';
          sessionStorage.removeItem('imgHead');
          sessionStorage.removeItem('name');
          sessionStorage.removeItem('permiss');
          sessionStorage.removeItem('loginKey'); 
          this.setPermiss(defaultPermissions);
      },
    },
  })
